import { ELanguages } from '../types'
import {
  EContactMe,
  EContactMeText,
  EETermsOfService,
  EEnFi,
  EEnFiAcceptanceOfTerms,
  EEnFiAcceptanceOfTermsText,
  EEnFiCustomer,
  EEnFiCustomerCompany,
  EEnFiChangesToTerms,
  EEnFiChangesToTermsText,
  EEnFiProductionBeginsWhen,
  EEnFiSupplier,
  EEnFiTermination,
  EEnFiTerminationText,
  EEnFiUseOfService,
  EEnFiUseOfServiceText,
  EEnFiWelcomeToTermsOfService,
  EEnFiCustomerResponsibleForCopyright,
  EEnFiSupplierNotResponsibleForErrors,
  EEnFiSupplierNotResponsibleForUpdates,
  EEnFiOrderIsBinding,
  EEnFiColorsMayVaryInPrintedWorks,
  EEnFiPrintingCostsNotIncluded,
  EEnFiSupplierMayUseProductInMarketing,
  EEnFiSupplierMayHelpWithHostingAndPrintingSolutions,
} from '../types/fien'
import { Link } from 'react-router-dom'
import { useLanguageContext } from '../contexts/LanguageContext'
import SEO from '../components/SEO/SEO'

export function TermsProducts({ language }: { language: ELanguages }) {
  const lang: EEnFi = language === ELanguages.fi ? EEnFi.fi : EEnFi.en

  return (
    <>
      <p>
        <strong>{EEnFiSupplier[lang]}:</strong> Jenniina Laine <br />
        <strong>{EEnFiCustomer[lang]}:</strong> {EEnFiCustomerCompany[lang]}
      </p>
      <p>{EEnFiProductionBeginsWhen[lang]}</p>
      <p>{EEnFiCustomerResponsibleForCopyright[lang]}</p>
      <p>{EEnFiSupplierNotResponsibleForErrors[lang]}</p>
      <p>{EEnFiSupplierNotResponsibleForUpdates[lang]}</p>
      <p>
        {EEnFiPrintingCostsNotIncluded[lang]}{' '}
        {EEnFiSupplierMayHelpWithHostingAndPrintingSolutions[lang]}
      </p>
      <p>{EEnFiColorsMayVaryInPrintedWorks[lang]}</p>
      <p>{EEnFiSupplierMayUseProductInMarketing[lang]}</p>
      <p>{EEnFiOrderIsBinding[lang]}</p>
    </>
  )
}

export default function TermsOfService({ type }: { type: string }) {
  const { t, language } = useLanguageContext()

  const lang: EEnFi = language === ELanguages.fi ? EEnFi.fi : EEnFi.en

  return (
    <>
      <SEO
        title={EETermsOfService[lang]}
        description={`${EEnFiWelcomeToTermsOfService[lang]} | ${EEnFiCustomer[lang]}`}
        canonicalUrl={'https://react.jenniina.fi/terms'}
      />
      <div className={`terms ${type}`}>
        <div className="inner-wrap">
          <section className={`card`}>
            <div>
              <p>{EEnFiWelcomeToTermsOfService[lang]}</p>
              <p>
                {t('SeeAlso')}: <Link to="/disclaimer">{t('Disclaimer')}</Link>
              </p>

              <h2>{EEnFiAcceptanceOfTerms[lang]}</h2>
              <p>{EEnFiAcceptanceOfTermsText[lang]}</p>

              <h2>{EEnFiChangesToTerms[lang]}</h2>
              <p>{EEnFiChangesToTermsText[lang]}</p>

              <h2>{EEnFiUseOfService[lang]}</h2>
              <p>{EEnFiUseOfServiceText[lang]}</p>

              <h2>{EEnFiTermination[lang]}</h2>
              <p>{EEnFiTerminationText[lang]}</p>

              <h2>{t('Products')}</h2>
              <TermsProducts language={language} />

              <h2>{EContactMe[lang]}</h2>
              <p>
                {EContactMeText[lang]}{' '}
                <Link to="/contact">{EContactMe[lang].toLowerCase()}</Link>
              </p>
            </div>
          </section>
        </div>
      </div>
    </>
  )
}
